// extracted by mini-css-extract-plugin
export default {"refinmentList":"refinmentList--d9717fb","ingredientList":"ingredientList--5b3c455","star":"star--5d2e76a","showingLess":"showingLess--aeb9a55","showingMore":"showingMore--ae7b568"};